/* istanbul ignore file */
import { createRouter } from 'vue-router'
import routerConfig from './config'
import middleware from './middleware'

export const router = createRouter(routerConfig)
middleware(router)
